// extracted by mini-css-extract-plugin
module.exports = {"LoginAndSecurity":"styles_LoginAndSecurity__3tZmF","LoginAndSecurity-content":"styles_LoginAndSecurity-content__r8loB"};